import React from 'react';
import { observer } from 'mobx-react-lite';
import { HalfCashOut } from './halfCashOut.js';
import { BetButton } from './betButton.js';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import { a1 as doBetStore, a2 as betDataStore, Q as userSettingsStore, $ as gameConfigStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import { gameStore } from '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';
import '../../../hooks/useTranslation.js';
import '../../../core/helpers/setTranslationValues.js';
import '../../../core/enums/additionalInputValueChangingButtons.js';
import './accumulatedPossibleWin.js';
import '../../../core/helpers/getAmountWithCurrency.js';
import '../../../core/enums/Currencies.js';

var DoBetBtnSection = observer(function (_a) {
    var sectionIndex = _a.sectionIndex;
    var doBetSectionsData = doBetStore.doBetSectionsData, freeBetDisable = doBetStore.freeBetDisable;
    var betButtonDisable = betDataStore.betButtonDisable;
    var _b = doBetSectionsData[sectionIndex], isBetAccepted = _b.isBetAccepted, freeBetId = _b.freeBetId, isDisabled = _b.isDisabled;
    var isBetsClosed = gameStore.isBetsClosed; gameStore.partnerWageringOdd; var partnerWageringDisabled = gameStore.partnerWageringDisabled;
    var isHalfCashOutOn = userSettingsStore.isHalfCashOutOn;
    var isGameHasHalfCashOut = gameConfigStore.isGameHasHalfCashOut;
    var disabled = betButtonDisable ||
        (isBetAccepted && !isBetsClosed) ||
        (isBetAccepted && partnerWageringDisabled) ||
        (isBetAccepted && freeBetDisable && freeBetId) ||
        isDisabled
        ? 'disabled'
        : '';
    return (React.createElement("div", { className: 'bet-section-left-top ' },
        React.createElement("div", { className: 'bet-section-left-top-bet' },
            React.createElement(BetButton, { sectionIndex: sectionIndex, disabled: disabled, isBetAccepted: isBetAccepted, isBetsClosed: isBetsClosed }),
            isBetAccepted && isHalfCashOutOn && isGameHasHalfCashOut && (React.createElement(HalfCashOut, { sectionIndex: sectionIndex, disabled: disabled, isBetsClosed: isBetsClosed })))));
});

export { DoBetBtnSection };
